import { makeClassName } from '@siteless/util';

const ChevronLeftIcon = ({
  className,
  ...rest
}: {
  className?: string;
  [x: string]: any;
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={makeClassName('feather feather-chevron-left', className)}
    {...rest}
  >
    <polyline points="15 18 9 12 15 6" fill="none" />
  </svg>
);

export default ChevronLeftIcon;
